import { Trophy, Flame, BookOpen, Target, Zap, Award, Star, CheckCircle } from 'lucide-react';

export const ACHIEVEMENTS = [
    {
        id: 'first_login',
        title: 'Langkah Pertama',
        desc: 'Login pertama kali ke dalam aplikasi',
        xpReward: 50,
        icon: 'Trophy', // String reference for dynamic rendering if needed, or component usage
        category: 'general'
    },
    {
        id: 'streak_3',
        title: 'On Fire!',
        desc: 'Login selama 3 hari berturut-turut',
        xpReward: 100,
        icon: 'Flame',
        category: 'streak'
    },
    {
        id: 'streak_7',
        title: 'Minggu Emas',
        desc: 'Login selama 7 hari berturut-turut',
        xpReward: 300,
        icon: 'Flame',
        category: 'streak'
    },
    {
        id: 'level_5',
        title: 'Rising Star',
        desc: 'Mencapai Level 5',
        xpReward: 200,
        icon: 'Star',
        category: 'level'
    },
    {
        id: 'level_10',
        title: 'Elite Student',
        desc: 'Mencapai Level 10',
        xpReward: 500,
        icon: 'Award',
        category: 'level'
    },
    {
        id: 'first_material',
        title: 'Kutu Buku',
        desc: 'Menyelesaikan materi pertama',
        xpReward: 50,
        icon: 'BookOpen',
        category: 'learning'
    },
    {
        id: 'quiz_master_novice',
        title: 'Quiz Novice',
        desc: 'Menyelesaikan 5 Quiz',
        xpReward: 100,
        icon: 'Target',
        category: 'quiz'
    },
    {
        id: 'perfect_score',
        title: 'Perfectionist',
        desc: 'Mendapatkan nilai 100 dalam sebuah quiz',
        xpReward: 150,
        icon: 'CheckCircle',
        category: 'quiz'
    }
];
